import { Autocomplete, TextField } from "@mui/material";
import { useEffect, useState } from "react";
import { EvaluationAssessor } from '../../common/Evaluation';
import { useGetAssessorsQuery } from '../../redux/api/evaluation';

interface EvaluationAssessorAutocompleteProps {
  id: string;
  vesselId: number;
  value: EvaluationAssessor | null;
  disabled?: boolean;
  onChange: (m: EvaluationAssessor | undefined) => void;
}

const EvaluationAssessorAutocomplete = (props: EvaluationAssessorAutocompleteProps) => {
  const [search, setSearch] = useState(!!props.value
      ? `${props.value.name}`
      : "")

  const [assessor, setAssessor] = useState<EvaluationAssessor | null>(props.value);

  useEffect(() => {
    setSearch(!!assessor
      ? `${assessor.name}`
      : "");
    // do not include search in the dependency array as it will lead to a loop and does not make sense here
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [assessor]);

  const { data: marinerProfiles, isLoading } =
    useGetAssessorsQuery({ search, vesselId: props.vesselId });

  return (
    <>
      {!isLoading && (
        <Autocomplete
          id={props.id}
          options={props.value 
            ? [ ...(marinerProfiles || []), props.value] 
            : (marinerProfiles || [])}
          value={assessor}
          onInputChange={(event, value: string) =>
            setSearch(value)
          }
          clearOnEscape={true}
          clearOnBlur={true}
          getOptionLabel={(profile) =>
            `${profile.name}${profile.mmcId ? ' - ' + profile.mmcId : ''}${profile.rating ? ' - ' + (profile.rating.startsWith("_") ? profile.rating.substring(1) : profile.rating) : ''}`
          }
          renderInput={(params) => <TextField {...params} />}
          onChange={(event, value) => {
            if (value) {
              props.onChange(value);
              setAssessor(value);
            } else {
              props.onChange(undefined);
              setAssessor(null);
            }
          }}
          isOptionEqualToValue={(option, value) => {
            return option.userId === value.userId;
          }}
          disabled={props.disabled ? props.disabled : false}
        />
      )}
    </>
  );
};

export default EvaluationAssessorAutocomplete;
